module.exports = __webpack_public_path__ + "img/nevsLogoRu.21dec13e.png";